<template>
  <v-dialog v-model="visible" max-width="500px" persistent>
    <v-card class="mb-0">
      <v-card-title class="headline">
        <v-icon left color="primary">mdi-soccer</v-icon>
        Asignar Nombre al Equipo
      </v-card-title>

      <v-card-text class="pt-4">
        <v-alert type="info" dense text class="mb-4">
          <div class="d-flex align-center">
            <v-icon left small>mdi-information</v-icon>
            <span>Ingrese el nombre del equipo de fútbol</span>
          </div>
        </v-alert>

        <v-text-field
          v-model="nombreEquipo"
          label="Nombre del Equipo"
          placeholder="Ej: Boca Juniors, River Plate, etc."
          outlined
          dense
          prepend-inner-icon="mdi-shield-star"
          :rules="[rules.required]"
          counter="50"
          maxlength="50"
          autofocus
          @keyup.enter="guardar"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar" color="grey" text> Cancelar </v-btn>
        <v-btn
          @click="guardar"
          color="primary"
          :disabled="!nombreEquipo || nombreEquipo.trim().length === 0"
        >
          <v-icon left small>mdi-check</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "AsignarNombreEquipo",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    nombreActual: {
      type: String,
      default: "",
    },
  },

  emits: ["close", "save"],

  setup(props, { emit }) {
    const nombreEquipo = ref("");

    const rules = {
      required: (v: string) => !!v || "El nombre es requerido",
    };

    // Sincronizar con el nombre actual cuando se abre el modal
    watch(
      () => props.visible,
      (visible) => {
        if (visible && props.nombreActual) {
          nombreEquipo.value = props.nombreActual;
        }
      },
      { immediate: true },
    );

    const cerrar = () => {
      nombreEquipo.value = "";
      emit("close");
    };

    const guardar = () => {
      const nombre = nombreEquipo.value.trim();

      if (!nombre) {
        return;
      }

      emit("save", nombre);
      nombreEquipo.value = "";
    };

    return {
      nombreEquipo,
      rules,
      cerrar,
      guardar,
    };
  },
});
</script>

<style scoped>
.v-text-field {
  font-size: 1rem;
}
</style>
